import girderRest from 'platform/web-girder/plugins/girder';
export const AnnotationsCurrentVersion = 2;
async function loadDetections(folderId, revision) {
    const params = { folderId };
    if (revision !== undefined) {
        params.revision = revision;
    }
    return {
        tracks: (await girderRest.get('dive_annotation/track', { params })).data,
        groups: (await girderRest.get('dive_annotation/group', { params })).data,
        version: AnnotationsCurrentVersion,
    };
}
function loadRevisions(folderId, limit, offset, sort) {
    return girderRest.get('dive_annotation/revision', {
        params: {
            folderId, sortdir: -1, limit, offset, sort,
        },
    });
}
function getLatestRevision(folderId) {
    return girderRest.get('dive_annotation/revision', {
        params: {
            folderId, sortdir: -1, limit: 1,
        },
    });
}
function saveDetections(folderId, args) {
    return girderRest.patch('dive_annotation', args, {
        params: { folderId },
    });
}
async function getLabels() {
    const response = await girderRest.get('dive_annotation/labels');
    return response;
}
export { getLabels, loadDetections, loadRevisions, getLatestRevision, saveDetections, };
